// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__y-wf5","footerLink":"Footer_footerLink__xVufR"};